<template>
	<el-dialog title="选择收货地址" :visible.sync="dialog" width="800px" :close-on-click-modal="false">
		<div>
			<div class="address-list" v-if="list.length > 0">
				<div v-for="item in list" class="address flex-between" :class="address.id==item.id?'active':''" @click="address = item">
					<div class="address-info" >
						<div><span>收货人：</span>{{item.receiveName}}</div>
						<div><span>联系方式：</span>{{item.phone}}</div>
						<div><span>收货地址：</span>{{item.province}}{{item.city}}{{item.county}}{{item.detailAddress}}</div>
					</div>
					<div class="address-action-icon" v-if="item.defaultStatus == 0">默认地址</div>
					<img v-if="address.id==item.id" src="@/assets/images/radio.png"/>
				</div>
			</div>
			
			<div class="address-form-button flex-center flex-midden">
				<el-button class="address-form-button-sbumit" type="primary" @click="submitForm">确定</el-button>
				<el-button class="address-form-button-close" type="primary" :loading="false" @click="dialog = false;">取消</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import {getAddressList} from "@/api/user"
export default {
	name: 'addressSelect',
	data(){
		return {
			list:[],
			dialog:false,
			address:null
		}
	},
	methods:{
		init(info){
			this.address = info;
			getAddressList({condition:{},page:1,size:100}).then(res=>{
				if(res.code == 1000){
					this.list = res.data.list;
					this.dialog = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		submitForm(){
			this.dialog = false;
			this.$emit("success", this.address);
		}
	}
}
</script>

<style scoped lang="scss">
	.address-list{
		height: 50vh;
		overflow: auto;
		.address{
			border: 1px solid rgba(0, 0, 0, 0.1);
			box-sizing: border-box;
			padding: 20px;
			margin-bottom: 16px;
			cursor: pointer;
			position: relative;
			.address-info{
				width: 100%;
				div{
					font-size: 14px;
					line-height: 18px;
					color: #070B13;
					padding: 4px 0px;
					span{
						width: 90px;
						color: rgba(7, 11, 19, 0.6);
						display: inline-block;
					}
				}
			}
			.address-action-icon{
				width: 104px;
				height: 28px;
				background: #E91A12;
				font-size: 14px;
				line-height: 28px;
				color: #FFFFFF;
				text-align: center;
				margin: 0 auto;
			}
			img{
				width: 24px;
				height: 24px;
				position: absolute;
				top:8px;
				right: 8px;
			}
		}
		.active{
			background: #FFF9F9;
			border: 1px solid #E91A12;
	
		}
	}
	::v-deep .el-button--primary:focus, .el-button--primary:hover{
		background: #E91A12;
		color: #FFFFFF;
		border: 1px solid #E91A12;
	}
	.address-form-button-sbumit{
		width: 160px;
		height: 46px;
		background: #E91A12;
		border: 1px solid #E91A12;
		font-size: 16px;
		font-weight: 500;
		text-align: center;
		color: #FFFFFF;
		margin: 0px 20px;
	}
	.address-form-button-close{
		width: 160px;
		height: 46px;
		background: #fff;
		border: 1px solid #E91A12;
		font-size: 16px;
		font-weight: 500;
		text-align: center;
		color:rgba(7, 11, 19, 1);
		margin: 0px 20px;
	}
	::v-deep .el-dialog__body{
		padding: 0px 60px 40px;
	}
	::v-deep .el-dialog__header{
		text-align: center;
		padding: 30px 20px 20px;
	}
</style>